<div class="management-plan-container">
  <h2>Annual Management Plan</h2>

  <table class="plan-table">
    <thead>
      <tr>
        <th class="align-left">Category (Type)</th>
        <th class="align-left">Action Items</th>
        <th *ngFor="let month of months">Month {{month}}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let category of managementPlan">
        <tr *ngFor="let item of category.items; let i = index">
          <td *ngIf="i === 0" [attr.rowspan]="category.items.length" class="align-left">{{category.type}}</td>
          <td class="align-left">{{item.name}}</td>
          <td *ngFor="let status of item.monthlyStatus; let monthIdx = index"
              [ngClass]="getStatusClass(status)"
              [title]="getStatusTooltip(status)">
            {{status.value !== null ? status.value : ''}}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <div class="legend">
    <div class="legend-item">
      <span class="status-pending"></span> Scheduled but not yet due
    </div>
    <div class="legend-item">
      <span class="status-due"></span> Due but not completed
    </div>
    <div class="legend-item">
      <span class="status-completed"></span> Due and completed
    </div>
    <div class="legend-item">
      <span class="status-issue"></span> Due but issues found
    </div>
  </div>
</div>
